import React from "react";
import {Checkbox, Table} from "react-bootstrap";
import {widgetMemberInfo} from "../models";

const MemberInfo = ({settings, onChange}) => {
    return (
        <Table>
            <thead>
                <tr>
                    <th>Показывать</th>
                    <th>Шрифт</th>
                </tr>
            </thead>
            <tbody>
                {widgetMemberInfo.map((info) => (
                    <tr key={info.value}>
                        <td>
                            <Checkbox
                                name={info.value}
                                checked={settings?.[info.value] || false}
                                onChange={(e) => onChange({[info.value]: e.target.checked})}
                            >
                                {info.label}
                            </Checkbox>
                        </td>
                        {!!info.bold && (
                            <td>
                                <Checkbox
                                    name={info.bold}
                                    checked={settings?.[info.bold] || false}
                                    onChange={(e) => onChange({[info.bold]: e.target.checked})}
                                >
                                    Bold
                                </Checkbox>
                            </td>
                        )}
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default MemberInfo;
